import React from 'react';
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  Alert,
  ThemeProvider,
  CssBaseline
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import { darkTheme } from './theme';

export default function LoginPage({ authUrl, alertMessage, noticeMessage }) {
  const handleGoogleSignIn = () => {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = authUrl;

    // Add CSRF token
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (csrfToken) {
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'authenticity_token';
      csrfInput.value = csrfToken;
      form.appendChild(csrfInput);
    }

    document.body.appendChild(form);
    form.submit();
  };

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'background.default',
          py: 8,
          px: 2,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={3}
            sx={{
              p: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3,
            }}
          >
            {/* Logo */}
            <Box
              component="img"
              src="/logo-white.png"
              alt="Freedom Power Logo"
              sx={{
                height: 60,
                mb: 2,
                objectFit: 'contain',
              }}
              onError={(e) => {
                // Hide image if logo doesn't exist yet
                e.target.style.display = 'none';
              }}
            />

            <Typography component="h1" variant="h4" fontWeight="bold">
              Willie Hart
            </Typography>

            <Typography variant="h6" color="text.secondary">
              Sign in to your account
            </Typography>

            {alertMessage && (
              <Alert severity="error" sx={{ width: '100%' }}>
                {alertMessage}
              </Alert>
            )}

            {noticeMessage && (
              <Alert severity="info" sx={{ width: '100%' }}>
                {noticeMessage}
              </Alert>
            )}

            <Box sx={{ width: '100%', mt: 2 }}>
              <Button
                fullWidth
                variant="contained"
                size="large"
                startIcon={<GoogleIcon />}
                onClick={handleGoogleSignIn}
                sx={{
                  py: 1.5,
                  textTransform: 'none',
                  fontSize: '1rem',
                }}
              >
                Sign in with Google
              </Button>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              Please use your Freedom Power email address
            </Typography>
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
}
